import React from 'react'
import magicStarsAnimation from 'common/json/lottie/MagicStarPulsing.json'
import Lottie from 'lottie-react'
import intl from 'react-intl-universal'

const MagicStarPulsing = ({ className, isCourseItem }: { className?: string, isCourseItem?: boolean }) => {
  return <Lottie className="w-6 h-6 mr-2" animationData={magicStarsAnimation}/>
}

export default MagicStarPulsing